import * as React from 'react';
import { useContext } from 'react';
import styled from 'styled-components';
import { Context, useLogger } from '../Context';
import { Disclaimers } from './Disclaimers';
import { ConsumptionAndEmissions } from './ConsumptionAndEmissions';

export interface StyledLegalWWrapperProps {
  isLandscapeSize?: boolean;
}

const StyledLegalInfo = styled.div<StyledLegalWWrapperProps>`
  padding-top: var(--spacing-relative-lg);
`;

export interface LegalInfoProps {
  consumptionAndEmissions?: string[];
  disclaimers?: string[];
}

export const LegalInfo: React.FC<LegalInfoProps> = ({ consumptionAndEmissions, disclaimers }) => {
  const { localeService, vueFormatterService } = useContext(Context);
  const hasContent = consumptionAndEmissions || (disclaimers && disclaimers.length);
  const logger = useLogger();
  // eslint-disable-next-line no-console
  logger?.info(localeService);

  // eslint-disable-next-line no-console
  logger?.info(vueFormatterService);

  if (!hasContent) return null;

  return (
    <StyledLegalInfo className="legal-info" data-testid="legal-info-section">
      {vueFormatterService && localeService && (
        <ConsumptionAndEmissions
          caeIds={consumptionAndEmissions}
          vueFormatterService={vueFormatterService}
          localeService={localeService}
        />
      )}
      <Disclaimers disclaimers={disclaimers} />
    </StyledLegalInfo>
  );
};

LegalInfo.displayName = 'LegalInfo';
